import ApiService from './api.service';

class PCSFormService {
  static async submitPCSForm(pcsFormData) {
    const url = `${window.ambulnzConfig.tenantedRestApiV2Url}/FormFill?type=pcs`;
    const response = await ApiService.post(url, pcsFormData);

    if (!response.ok) {
      let errorDetails = '';
      try {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          errorDetails = errorData.message || errorData.error || JSON.stringify(errorData);
        } else {
          errorDetails = await response.text();
        }
      } catch (parseError) {
        errorDetails = 'Unable to parse error response';
      }

      const error = new Error(
        `PCS Form Submission Failed - Status: ${response.status}${
          response.statusText ? ` ${response.statusText}` : ''
        } - ${errorDetails}`,
      );
      error.status = response.status;
      error.statusText = response.statusText;
      error.url = url;
      error.details = errorDetails;
      throw error;
    }

    return response.blob();
  }
}

export default PCSFormService;
